export default __webpack_public_path__ + "static/media/burjeel-edit-icon.5c66144b.svg";